export enum VATDisplayType {
    HTVA    ,
    TVAC,
    BOTH
}